import React from 'react';
import Modal from '../common/Modal.mjs';

export default function LegalModal({ isOpen, onClose }) {
    return (
        <Modal isOpen={isOpen} onClose={onClose} title="Legal Information">
            <div className="legal-content">
                {/* ── Beta / Test Mode Banner ── */}
                <div className="legal-banner" style={{
                    background: 'var(--color-warning-bg, rgba(255, 193, 7, 0.12))',
                    border: '1px solid var(--color-warning-border, rgba(255, 193, 7, 0.3))',
                    borderRadius: '8px',
                    padding: '12px 16px',
                    marginBottom: '20px',
                    fontSize: '0.9rem',
                }}>
                    <strong>⚠️ Beta / Test Mode</strong>
                    <p style={{ margin: '6px 0 0' }}>
                        Nexus of Truth is currently in test mode. By using this application you
                        acknowledge that it is provided on an as-is, experimental basis. Features
                        may change, break, or be removed without notice.
                    </p>
                </div>

                <h3 className="text-xl font-semibold mb-4">Terms of Service</h3>
                <p className="mb-4">
                    By accessing and using Nexus of Truth you agree to the following terms. Please
                    review them carefully before creating an account or using any features.
                </p>

                <h4 className="text-lg font-medium mb-2">1. Assumption of Risk</h4>
                <p className="mb-4">
                    This application is in active development and is provided for <strong>testing
                        and evaluation purposes only</strong>. You use it entirely at your own risk.
                    We make no guarantees regarding uptime, data integrity, or the continued
                    availability of any feature. We are not liable for any loss or damage arising
                    from your use of the service.
                </p>

                <h4 className="text-lg font-medium mb-2">2. Content &amp; Intellectual Property</h4>
                <p className="mb-4">
                    All content, AI-generated analysis, graphics, and design assets on Nexus of
                    Truth are protected under applicable copyright and proprietary laws. Copying,
                    redistribution, or republication without express permission is strictly
                    prohibited. AI-generated content is provided for informational purposes only
                    and should not be relied upon as professional advice.
                </p>

                <h4 className="text-lg font-medium mb-2">3. User Accounts</h4>
                <p className="mb-4">
                    When you create an account you provide personal information including your
                    name, email address, screen name, and a password. You are responsible for
                    maintaining the confidentiality of your credentials and for all activity under
                    your account. Accounts may be deleted or reset at any time during the test
                    period.
                </p>

                <h4 className="text-lg font-medium mb-2">4. Ratings, Reviews &amp; Machine Learning</h4>
                <p className="mb-4">
                    When you submit star ratings and written reviews, that data — including the
                    review text, star rating, quick-select chip choice, and computed sentiment
                    scores — may be used to <strong>train and improve internal machine learning
                        models</strong> that enhance content quality assessment across the platform.
                    Review data is stored in anonymized or pseudonymized form for ML training
                    purposes. By submitting a review you grant us a non-exclusive, royalty-free
                    license to use that content for service improvement, including ML model
                    training.
                </p>

                <h3 className="text-xl font-semibold mb-4 mt-6">Privacy &amp; Data Notice</h3>

                <div className="legal-banner" style={{
                    background: 'var(--color-error-bg, rgba(239, 68, 68, 0.08))',
                    border: '1px solid var(--color-error-border, rgba(239, 68, 68, 0.25))',
                    borderRadius: '8px',
                    padding: '12px 16px',
                    marginBottom: '16px',
                    fontSize: '0.9rem',
                }}>
                    <strong>🔒 Important Data Protection Disclaimer</strong>
                    <p style={{ margin: '6px 0 0' }}>
                        While in test mode, we <strong>cannot guarantee full compliance</strong> with
                        CCPA, GDPR, or other data-protection regulations. If this is a concern,
                        please do not create an account or provide personal information.
                    </p>
                </div>

                <h4 className="text-lg font-medium mb-2">1. Information We Collect</h4>
                <p className="mb-4">
                    We collect information you provide during account creation: first name, last
                    name, email address, screen name, and a hashed password. We may also collect
                    usage data such as pages visited and features used to improve the service.
                </p>

                <h4 className="text-lg font-medium mb-2">2. How We Use Your Information</h4>
                <p className="mb-4">
                    Your information is used solely to operate the application, authenticate your
                    sessions, and improve the service. We do not sell or share your personal
                    information with third parties for marketing purposes.
                </p>

                <h4 className="text-lg font-medium mb-2">3. Data Retention &amp; Deletion</h4>
                <p className="mb-4">
                    Because this service is in test mode, stored data — including your account and
                    any associated content — may be purged at any time without prior notice. If you
                    wish to have your data removed, please contact us and we will delete your
                    account and associated information.
                </p>

                <h4 className="text-lg font-medium mb-2">4. Review Data &amp; ML Training</h4>
                <p className="mb-4">
                    Star ratings, review text, and associated metadata (sentiment scores,
                    quick-select chip choices) are collected when you submit article reviews.
                    This data may be used to train machine learning models that improve content
                    quality assessment. Review data used for ML training is stored separately
                    from your personal information and is processed in aggregate or anonymized
                    form. You may request deletion of your review data at any time.
                </p>

                <h4 className="text-lg font-medium mb-2">5. No Warranty</h4>
                <p className="mb-4">
                    This service is provided &quot;as is&quot; and &quot;as available&quot; without
                    warranty of any kind, express or implied, including but not limited to the
                    implied warranties of merchantability, fitness for a particular purpose, or
                    non-infringement. Use of this service during the test period constitutes
                    acceptance of these terms.
                </p>
            </div>
        </Modal>
    );
}
